<template>
    <div class="en_add enterprise_add">
        <el-card>
            <el-page-header style="margin-bottom: 30px;" @back="goBack" />
            <el-form ref="form" :model="form" :rules="rule" label-width="110px" :inline="false" size="normal">
                <el-form-item label="企业简称" prop="name">
                    <el-col :span="8">
                        <el-input v-model="form.name" show-word-limit />
                    </el-col>
                </el-form-item>
                <el-form-item label="企业全称" prop="fullName">
                    <el-col :span="8">
                        <el-input v-model="form.fullName" />
                    </el-col>
                </el-form-item>
                <el-form-item label="企业logo" prop="logo">
                    <imgup :action="action" :banner="form.logo" :tip_text="false" @event="setImg" />
                </el-form-item>
                <el-form-item label="公司官网" prop="website">
                    <el-col :span="8">
                        <el-input v-model="form.website" />
                    </el-col>
                </el-form-item>
              <el-form-item label="邮箱" >
                <el-col :span="8">
                  <el-input v-model="form.email" />
                </el-col>
              </el-form-item>
              <el-form-item label="手机号码" >
                <el-col :span="8">
                  <el-input v-model="form.phone" />
                </el-col>
              </el-form-item>
                <el-form-item label="实际办公地址" prop="city">
                    <div class="flex-align">
                        <div>
                            <el-select
                                v-model="form.province"
                                placeholder="省份"
                                style="width: 130px; margin-right: 12px"
                                @change="op"
                            >
                                <el-option
                                    v-for="item in province"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code"
                                />
                            </el-select>
                            <el-select v-model="form.city" placeholder="城市" style="width: 130px; margin-right: 12px">
                                <el-option
                                    v-for="item in city"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code"
                                />
                            </el-select>
                            <div class="box">
                                <el-input v-model="form.address" :maxlength="100" show-word-limit />
                            </div>
                        </div>
                        <el-button type="text" icon="el-icon-circle-plus" style="margin-left: 10px;" @click="addMore"
                            >添加更多</el-button
                        >
                    </div>
                    <office-address
                        :province="province"
                        :detail="item"
                        :index="index"
                        v-model="form.otherAddress"
                        v-for="(item, index) in form.otherAddress"
                        :key="index"
                    ></office-address>
                </el-form-item>
                <el-form-item label="公司人数" prop="people">
                    <el-select v-model="form.people" placeholder="请选择公司人数">
                        <el-option
                            v-for="(item, index) in $store.state.enterprise_config &&
                                $store.state.enterprise_config.enterprisePeople"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key * 1"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="融资情况" prop="financing">
                    <el-select v-model="form.financing" placeholder="请选择融资情况">
                        <el-option
                            v-for="(item, index) in $store.state.enterprise_config &&
                                $store.state.enterprise_config.enterpriseFinancing"
                            :key="index"
                            :label="item.value"
                            :value="item.key * 1"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="类型" prop="type">
                    <el-checkbox-group
                        v-model="form.type"
                        :max="3"
                        @change="
                            form.business = [];
                            form.subBusiness = [];
                            businessChange()
                        "
                    >
                        <el-checkbox v-for="(item, index) in typeList" :key="item.id" :label="item.id + ''">{{
                            item.name
                        }}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="行业" prop="business">
                    <el-checkbox-group
                        v-model="form.business"
                        v-if="form.business.length > 3"
                        @change="form.subBusiness = []"
                    >
                        <el-checkbox v-for="(item, index) in businessList" :key="item.id" :label="item.id + ''">{{
                            item.name
                        }}</el-checkbox>
                    </el-checkbox-group>
                    <el-checkbox-group v-model="form.business" :max="3" @change="form.subBusiness = [];businessChange()" v-else>
                        <el-checkbox v-for="(item, index) in businessList" :key="item.id" :label="item.id + ''">{{
                            item.name
                        }}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="二级行业" prop="subBusiness">
                    <el-checkbox-group v-model="form.subBusiness" :max="3" @change="businessChange">
                        <el-checkbox v-for="(item, index) in subBusinessList" :key="item.id" :label="item.id + ''">{{
                            item.name
                        }}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

              <el-form-item label="企业标签">
                <el-select v-model="form.labelIds" multiple placeholder="请选择">
                  <el-option
                      v-for="item in enterpriseLabelList"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="行业标签" prop="tagBusiness">
                <el-select v-model="form.tagBusiness" multiple placeholder="请选择">
                  <el-option
                      v-for="item in tagBusinessList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="业务区域" >
                <el-col :span="8">
                  <div class="input-detail"  @mouseenter="querySearchAsync" @mouseleave="toClose">
                    <el-input placeholder="输入企业名称模糊查询" class="clear-input"
                              v-model="state"  type="text" name="" id=""
                              @input="querySearchAsync"  />
                    <div class="theSearchBox" v-if="searchInput" >
                      <div v-if="searchList.length">
                        <div class="item flex-align" @click="handleBusinessArea(item)" v-for="(item, index) in searchList" :key="item.id">
                          {{item.name}}({{item.code}})
                        </div>
                      </div>
                      <div class="no-data" v-else>
                        <img src="https://cdn-img.yfchuhai.com/www.yfchuhai.com/static/pc/admin/no-data.png">
<div>
  暂无数据
</div>
                      </div>
                      <!--          <div class="foot">-->
                      <!--            <div class="add-text">搜索不到您要添加的企业，请联系客服添加</div>-->
                      <!--            <img src="https://cdn-img.yfchuhai.com/www.yfchuhai.com/static/pc/img/index/grounp/anan_code.jpg" alt="" />-->
                      <!--          </div>-->
                    </div>
                  </div>

                </el-col>
                <el-col :span="8" :offset="0" style="margin-left: 10px">
                  <div class="list-content" v-if="form.businessArea.length">
                    <el-tag
                        v-for="tag in form.businessArea"
                        :key="tag.name"
                        closable
                        @close="handleCloseTag(tag)"
                        style="margin: 2px 5px 2px 0px"
                        :type="tag.type">
                      {{tag.name}}
                    </el-tag>
                  </div>
                </el-col>
              </el-form-item>
                <el-form-item label="企业介绍">
                    <el-col :span="8" :offset="0">
                        <el-input v-model="form.intro" type="textarea" :rows="6" placeholder="请输入内容" />
                    </el-col>
                </el-form-item>
                <el-form-item label="企业简介" prop="intro">
                    <el-col :span="8" :offset="0">
                        <el-input v-model="form.companyDesc" type="textarea" :rows="6" placeholder="请输入内容" />
                    </el-col>
                </el-form-item>
                <el-form-item label="上传经典案例" prop="caseFile">
                    <el-col :span="8" :offset="0">
                        <up-file tip="请上传PDF文件，大小不可超过60M。" v-model="form.caseFile" type="pdf"></up-file>
                    </el-col>
                </el-form-item>
                <el-form-item label="上传服务bp" prop="serviceFile">
                    <el-col :span="8" :offset="0">
                        <up-file tip="请上传PDF文件，大小不可超过60M。" v-model="form.serviceFile" type="bp"></up-file>
                    </el-col>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="medium" @click="onSubmit">{{ id ? "修改" : "提交" }}</el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>
import imgup from "../../components/upImg/index.vue";
import rules from "../../utils/rules";
import imgups from "../../components/uplist/index.vue";
import officeAddress from "./office-address.vue";
import {debounce} from "@/utils/methods";
export default {
    components: {
        imgup,
        imgups,
        officeAddress,
    },
    data() {
        return {
          state:'',
          searchList:[],
          searchInput:false,

            id: null,
            form: {
              businessArea:[],
              tagBusiness:'',
                name: "",
                fullName: "",
                logo: "",
                website: "",
                province: "",
                city: "",
                address: "",
                people: "",
                financing: "",
                type: [],
                business: [],
                subBusiness: [],
                serverArea: [],
                companyDesc: "",
                productDesc: "",
                productImages: [],
                serviceClose: 1,
                serviceFile: "",
                otherAddress: [],
                intro: "",
              labelIds:[],
              phone:'',
              email:''
            },

            rule: {
                name: [rules.req("请输入企业简称")],
                fullName: [rules.req("请输入企业全称")],
                logo: [rules.req("请输入企业logo")],
                city: [rules.req("请输入省份和城市")],
                people: [rules.req("请输入公司人事")],
                financing: [rules.req("请输入融资情况")],
                type: [rules.req("请输入类型")],
                business: [rules.req("请输入行业")],
                serverArea: [rules.req("请输入业务区域")],
                companyDesc: [rules.req("请输入企业介绍")],
                intro: [rules.req("请输入企业简介")],
              tagBusiness:[rules.req("请选择行业标签")],
            },
            action: {
                action: "enterprise",
            },
            province: {},
            city: {},
            typeList: [],
            businessList: [],
            subBusinessList: [],
          tagBusinessList:[],
            baseurl: this.$store.state.env.cdnStatic,
            yu: "/" + this.$store.state.env.domain,
          enterpriseLabelList:[]
        };
    },
    watch: {
        "form.type"(newValue, oldValue) {
            this.getType("1");
        },
        "form.business"(newValue, oldValue) {
            this.getType("2");
        },
    },
    computed: {},
    created() {
        this.getform();
        this.getp();
        this.getType();
        this.getTagBusinessList()
        this.bus.$on("new", () => {
            this.form = this.$options.data.call(this).form;
            this.id = null;
        });
    },
    methods: {
      handleCloseTag(item){
        this.form.businessArea = this.form.businessArea.filter(i=>i.id !=item.id)
      },
      handleBusinessArea(item){
        let i =  this.form.businessArea.find(i=> i.id === item.id);
        if(i){
          this.$message.info("该区域已选择过");

        }else {
          this.form.businessArea.push(item)
          this.$message.success("添加成功");


        }
      },
      toClose() {
        setTimeout(() => {
          this.searchInput = false;
        }, 500);
      },
      querySearchAsync: debounce(async function () {
        this.state=this.state.trim()
        const { data } = await this.$http.get(
            '/admin/EnterpriseBusinessArea/getList' ,{params:{
                page:'1',
                pageSize:'300',
                keyword:this.state}}
        );
        this.searchList = data.data.list;
        this.searchInput = true;
      }),
      businessChange(){
        this.getEnterpriseLabel();
        this.form.labelIds=[]
      },
        c_img(val) {
            this.form.productImages = val;
        },
        chang(val) {
            this.form.serviceDesc = val;
        },
        goBack() {
            this.$router.go(-1);
        },
        async getp() {
            const res = await this.$store.dispatch("getProvince");
            this.province = res.data;

            //   setTimeout(()=>{
            //   },200)
        },
        addMore() {
            this.form.otherAddress.push({ province: "", city: "", address: "" });
        },
        async getc(val) {
            if (!val) this.form.city = "";
            const { data: res } = await this.$store.dispatch("getCity", this.form.province);
            this.city = res;
        },
        op() {
            this.getc();
        },
        async onSubmit() {
            var url = this.form.productImages.map((item) => item.url);
            var submitBusinessArea=this.form.businessArea.map(item=>{
              return item.id
            })
            url = url.join(",");
            let form = {
                ...this.form,
                business: this.form.business.join(","),
                serverArea: this.form.serverArea.join(","),
                type: this.form.type.toString(),
                subBusiness: this.form.subBusiness.toString(),
                productImages: url,
                otherAddress: JSON.stringify(this.form.otherAddress),
              tag:this.form.tagBusiness.join(','),
              labelIds:this.form.labelIds.join(','),
              businessArea:submitBusinessArea.join(',')
            };
            if (this.id) {
                var { data: res } = await this.$http.post("/admin/Enterprise/edit", {
                    ...form,
                    id: this.id,
                });
                if (res.errorCode == 200) {
                    this.$message.success(res.message);
                    history.back();
                }
            } else {
                var { data: res } = await this.$http.post("/admin/Enterprise/add", form);
                if (res.errorCode == 200) {
                    this.$message.success(res.message);
                    this.$router.push("/enterprise_cert_list");
                }
            }
        },
      async getTagBusinessList(val){
        var { data: res } = await this.$http.get(
            `/admin/Enterprise/getTag`
        );

        this.tagBusinessList=res.data.list
      },
      async getEnterpriseLabel(){
        var { data: res } = await this.$http.get(
            `/admin/Enterprise/getEnterpriseLabel?type=${this.form.type}&business=${this.form.business}`
        );
        this.enterpriseLabelList=res.data
      },
        async getType(val) {
            if (val == 1) {
                var { data: res } = await this.$http.get(
                    `/admin/EnterpriseCategory/getList?keyword=&page=1&pageSize=100&order=&typeId=${this.form.type.toString()}&businessId=`
                );
                if (!this.form.type.length) {
                    this.businessList = [];
                    return;
                }
                this.businessList = res.data.list;
                return;
            }
            if (val == 2) {
                var { data: res } = await this.$http.get(
                    `/admin/EnterpriseCategory/getList?keyword=&page=1&pageSize=100&order=&typeId=${this.form.type.toString()}&businessId=${this.form.business.toString()}`
                );
                if (!this.form.business.length) {
                    this.subBusinessList = [];
                    return;
                }
                this.subBusinessList = res.data.list;
                return;
            }
            var { data: res } = await this.$http.get(
                "/admin/EnterpriseCategory/getList?keyword=&page=1&pageSize=100&order=&typeId=0&businessId="
            );
            this.typeList = res.data.list;
        },
        async getform() {
            if (this.$route.query.id) {
                var id = this.$route.query.id;
                this.id = id;
                this.$http.get("/admin/Enterprise/getById?id=" + id).then(({ data: res }) => {
                    if (res.errorCode == 200) {
                        // console.log(res);
                        var yyds = res.data.productImages.split(",");
                        var url = [];
                        yyds.forEach((item) => {
                            if (item) {
                                url.push({
                                    name: "1",
                                    url: item,
                                });
                            }
                        });
                        this.form = {
                            ...res.data,
                            business: res.data.business.split(",").filter(Boolean),
                            serverArea: res.data.serverArea.split(",").filter(Boolean),
                            type: res.data.type.toString().split(","),
                            subBusiness: res.data.subBusiness.split(",").filter(Boolean),
                            productImages: url,
                            otherAddress: res.data.otherAddress || [],
                            tagBusiness: res.data.tag?res.data.tag.split(',').map(item=>Number(item)) : [],
                          labelIds:res.data.labelIds?res.data.labelIds.split(',').map(item=>Number(item)) : [],
                        };

                        this.form.province && this.getc(1);
this.getEnterpriseLabel()
                        console.log(this.form);
                        this.form.id = id * 1;
                        //  this.form.initViews =
                        //   Math.floor(Math.random() * (200 - 50 + 1)) + 50
                    }
                });
            }
        },
        setImg(val) {
            this.form.logo = val;
        },
    },
};
</script>

<style lang="less">
.en_add {
    .box {
        display: inline-block;
        width: 300px;
        input {
            border-color: #dcdfe6 !important;
        }
    }
}
.input-detail {
  width:100%;
  height: 38px;
  background: #ffffff;
  //border: 1px solid #dcdfe6;
  position: relative;
  border-radius: 4px;
  z-index: 2;

}
:deep(.el-card .el-card__body){
  padding: 0 30px;
}
.input-tip {
  color: #9EA2B5;
  font-size: 14px;
  margin-top: 17px;
  line-height: 1.5;
  span{
    color: #E2241B;
  }
}
.theSearchBox {
  width: 368px;
  height: 400px;
  overflow: auto;
  background: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
  border-radius: 15px;
  padding: 10px 25px;
  position: absolute;
  top: 40px;
  left: 0px;

  .undata {
    width: 89px;
    height: 34px;
    background: #0a7ff2;
    border-radius: 17px;
    color: #fff;
    line-height: 34px;
    text-align: center;
    cursor: pointer;
  }

  .foot {
    margin-top: 20px;
    text-align: center;

    .add-text {
      color: #333333;
      font-size: 16px;
    }

    img {
      width: 165px;
      height: 165px;
      margin-top: 30px;
    }


  }
  .item {
    // margin-bottom: 30px;
    padding: 2px 0;
    border-bottom: 1px solid rgba(229, 229, 229, 0.6);
cursor: pointer;
    &:first-child {
      padding-top: 0;
    }

    img {
      width: 54px;
      height: 54px;
      border-radius: 10px;
      flex-shrink: 0;
    }

    .desc {
      font-size: 18px;
      font-weight: 400;
      color: #333333;
      margin-left: 22px;
      width: 190px;
    }

    .btn {
      width: 90px;
      height: 35px;
      border: 1px solid #0a7ff2;
      border-radius: 17px;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      color: #0a7ff2;
      line-height: 35px;
      margin-left: auto;
      flex-shrink: 0;
      cursor: pointer;
    }
  }
}
.list {
  margin-top: 30px;
  display: grid;
  grid-template-columns: repeat(3,1fr);
  grid-gap: 10px;
  .list-item {
    flex-direction: column;
    width: 100px;
    height: 100px;
    background: #ffffff;
    border: 1px solid #f2f2f2;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    margin-right: 10px;
    margin-bottom: 10px;
    padding: 10px;
    display: flex;

    &:hover {
      .box {
        display: flex;
      }
    }

    >img {
      width: 80px;
      height: 80px;
      border-radius: 6px;
      margin-bottom: 5px;
    }

    .desc {
      width: 90px;
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      overflow: hidden;
      white-space: nowrap;
      text-overflow:ellipsis;
      text-align: center;
    }

    .box {
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);

      .btn {
        width: 100px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        background: #ffffff;
        border-radius: 21px;
        color: #0a7ff2;
        font-size: 18px;
      }
    }
  }
}
.no-data{
  width: 100%;
  height: 100%;
  color: #a5b4e6;
  font-size: 14px;
  text-align: center;
  img{
    width: 200px;
    height: 200px;
    margin: 50px auto 20px;
  }
  .no-data-text{

  }
}
</style>
